import { useContext, useEffect, useMemo, useRef, useState } from "react";
// import "./Hero.css"
import { Link } from "react-router-dom";
import Experience from "../Experience/Experience";
import Project from "../Project/Project";
import About from "../About/About";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { SiHellofresh } from "react-icons/si";
import Services from "../Services/services";
import Contact from "../Contacts/Contact";
import Marquee from "react-fast-marquee";
import "../../Style/Project.css";

import video from "../../Assets/video.mp4";
import invoice from "../../Assets/invoice.mp4";
import compressor from "../../Assets/compressor.mp4";
import noteApp from "../../Assets/note-web.mp4";
import { Helmet } from "react-helmet";
import { CiDark } from "react-icons/ci";
import { CiLight } from "react-icons/ci";
import { ThemeContext } from "../../Theme/ThemeContext";

const Home = () => {
   const {theme, setTheme } = useContext(ThemeContext);
  //  const [theme, setTheme] = useState('theme-white'); // Default theme
  const [mode, SetMode] = useState(!true);
  const h1Ref = useRef(null);
  const headingRef = useRef(null);
  const handleMode = () => {
    SetMode(!mode);
  };
  //................gssssaaaaaapppppppppppppppppp...............................................................//


//   useEffect(() => {
//      gsap.fromTo(
//   "#HeroSection",
//   {
//     x: 0,
//     opacity: 1,
//   },
//   {
//     x: 300, // moves right on scroll
//     opacity: 0.5, // optional fade
//     ease: "power2.out",
//     scrollTrigger: {
//       trigger: "#HeroSection",
//       start: "top center",
//       end: "bottom top",
//       scrub: true,
//       markers: true // remove this in production
//     },
//   }
// );

      
     
//     }, []);
    
  useGSAP(() => {
    gsap.to(".spinner-herosection", {
      rotate: 360,
      duration: 5,
      repeat: -1,
      ease: "linear",
    });
  });

  const breakTextIntoSpans = (text) => {
    return text.split("").map((letter, index) => (
      <span
        key={index}
        className="letter-span"
        style={{ display: "inline-block" }}
      >
        {letter}
      </span>
    ));
  };

  // UseEffect to handle GSAP animations
  useEffect(() => {
    if (h1Ref.current) {
      const letters = h1Ref.current.querySelectorAll(".letter-span");
      const anim1 = gsap.from(letters, {
        y: 70,
        opacity: 0,
        duration: 1,
        stagger: 0.3,
        delay: 7,
      });
      const anim2 = gsap.from(headingRef.current, {
        duration: 1,
        opacity: 0,
        y: -50,
        delay: 1,
        ease: "bounce.out",
      });

      return () => {
        anim1 && anim1.kill();
        anim2 && anim2.kill();
      };
    }
  }, []);

  // ........................................................................................

  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000); // Update every second

    return () => clearInterval(intervalId); // Cleanup on component unmount
  }, []); // Empty dependency array to run the effect only once on mount

  // Function to format time in HH:mm:ss AM/PM
  // Function to format time in HH:mm:ss AM/PM
  const formatTime = (time) => {
    const hours = time.getHours();
    const minutes = time.getMinutes();
    const seconds = time.getSeconds();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

    return `${formattedHours}:${minutes < 10 ? "0" : ""}${minutes}:${
      seconds < 10 ? "0" : ""
    }${seconds} ${ampm}`;
  };

  const memoizedTime = useMemo(() => formatTime(time), [time]);

  // .................................................................................

  /* -- Text effect -- */

  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const [intervalId, setIntervalId] = useState(null);

  const handleMouseOver = (event) => {
    let iteration = 0;

    clearInterval(intervalId);

    const newIntervalId = setInterval(() => {
      event.target.innerText = event.target.innerText
        .split("")
        .map((letter, index) => {
          if (index < iteration) {
            return event.target.dataset.value[index];
          }

          return letters[Math.floor(Math.random() * 26)];
        })
        .join("");

      if (iteration >= event.target.dataset.value.length) {
        clearInterval(newIntervalId);
      }

      iteration += 1 / 3;
    }, 30);

    setIntervalId(newIntervalId);
  };
  useEffect(() => {
    return () => {
      clearInterval(intervalId);
    };
  }, [intervalId]);

  // ....onPage Load....................................................................


  const startAnimation = (target) => {
    let iteration = 0;

    clearInterval(intervalId);

    const newIntervalId = setInterval(() => {
      target.innerText = target.innerText
        .split("")
        .map((letter, index) => {
          if (index < iteration) {
            return target.dataset.value[index];
          }

          return letters[Math.floor(Math.random() * 26)];
        })
        .join("");

      if (iteration >= target.dataset.value.length) {
        clearInterval(newIntervalId);
      }

      iteration += 1 / 3;
    }, 50);

    setIntervalId(newIntervalId);
  };

  // useEffect(() => {
  //   const targetElement = document.querySelector(".for-text-animation");

  //   if (targetElement) {
  //     startAnimation(targetElement);
  //   }

  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []);

    useEffect(() => {
    const timer = setTimeout(() => {
      const targetElement = document.querySelector(".for-text-animation");
      if (targetElement) {
        startAnimation(targetElement);
      }
    }, 8000); // 8 seconds delay

    return () => {
      clearTimeout(timer);
      clearInterval(intervalId);
    };
  }, []);
  // ..................................................................................................................................

  // ............................................................................................
  // const scrollEl = useRef(null);
  // useEffect(() => {
  //   // if (!start) return;
  //   const LocoScroll = new LocomotiveScroll({
  //     el: scrollEl.current,
  //     smooth: true,
  //     multiplier: 1,
  //     lerp: 0.05,
  //     class: "is-reaveal",
  //   });

  //    return () => {
  //      LocoScroll.destroy()
  //   }
  // }, []);

  // ............................................................................................

  const handleClick = () => {
    // window.location.href = 'https://food-dost.vercel.app/';

    window.open("https://note-app-web-five.vercel.app/", "_blank");
  };

  const handleClick_1 = () => {
    // window.location.href = 'https://food-dost.vercel.app/';
    window.open("https://invoice-genrator-ruby.vercel.app/", "_blank"); // Replace with your desired URL
  };

  const handleClick_2 = () => {
    window.open("https://image-compressor-blue-six.vercel.app/", "_blank");
  };

  const handleClick_3 = () => {
    window.open("https://food-dost.vercel.app/", "_blank"); // Replace with your desired URL
  };

  // ..................................................................................................................................

const [showHeroDiv, setShowHeroDiv] = useState(false);
  const heroDivRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!showHeroDiv && window.scrollY > 50) {
        setShowHeroDiv(true);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [showHeroDiv]);


  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home</title>
        <link rel="canonical" href="http://piyushsinghdev/home" />
      </Helmet>

      <svg class="myfilter " width="100%" height="100%">
        <filter id="noise">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.80"
            numOctaves="4"
            stitchTiles="stitch"
          ></feTurbulence>
        </filter>
        <rect width="100%" height="100%" filter="url(#noise)"></rect>
      </svg>
      {/* for scorllbar when going down */}
      <div className="hero-section-div1" 
      >
        <p className="hero-section-div1-based-in-india">
          Based in India {<MdOutlineArrowRightAlt className="arrowright" />}{" "}
          <strong className="hero-section-div1-based-in-india">
            {" "}
            {memoizedTime}
          </strong>
        </p>
        <p className="hero-section-div1-open-to-work">
          <strong>✦ </strong>
          Status {<MdOutlineArrowRightAlt className="arrowright" />}{" "}
          <strong className="hero-section-div1-open-to-work">
            Open to Work
          </strong>
        </p>
      </div>

      <header className={`header ${theme}`} id="HeroSection"    data-scroll-section>
        <div className="main-hero-section">
          {/* <h1>
            <span className="hero-section-h1-intro">Hi, this is Piyush.</span>
          </h1> */}
          <h1
            className={`hero-section-h1-intro-main  for-text-animation  ${theme} `}
            // onMouseOver={handleMouseOver}
            data-value="FULLSTACK"
          >
            FULLSTACK
          </h1>
          <h1
            className={`hero-section-h1-intro-main  for-text-animation  ${theme} `}
            onMouseOver={handleMouseOver}
            data-value="WEB"
          >
            WEB
          </h1>
          {/* <h1 ref={h1Ref} className="hero-section-h1-intro-main">
                            DEVELOPER</h1> */}
          <h1
            ref={h1Ref}
            className={`hero-section-h1-intro-main-developer ${theme} `}
            style={{ overflow: "hidden" }}
          >
            {breakTextIntoSpans("DEVELOPER")}
          </h1>

          {/* <h1 className="hero-section-h1-intro-main">
            & 3D{" "} */}

          {/* </h1> */}
          {/* <div className="hero-section-div-title">
                            <h1 className="hero-section-h1-intro" data-value="Hi, this is Piyush."
                                style={{ marginTop: "-0px" }} >
                                Hi, this is Piyush.
                            </h1>

                        </div> */}
          {/* <h1 style={{ color: "white" }}>
                            /GSAP
                        </h1> */}
          <h1 className={`hero-section-h1-intro-main-designer ${theme}`}>
            DESI
            <svg
              className="spinner-herosection"
              xmlns="http://www.w3.org/2000/svg"
              width="168"
              height="193"
              viewBox="0 0 168 193"
              fill="none"
            >
              <path
                d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
                fill="#D6D1CE"
              />
            </svg>
            {/* <span
              ref={headingRef}
              className="hero-section-main-intro-span-gilroy"
            >
            </span> */}
            GNER
          </h1>

          <div className="my-intro">
            <div className="my-intro-div-1">
              <h1 className={`my-intro-h1 ${theme}`}>Hi,</h1>
              <h1 className={`my-intro-h2 ${theme}`}>I am Piyush</h1>
              <p className="my-intro-h3 ">
                A passionate Front end Developer 🚀.Develop highly interactive Front end / User Interfaces for your web and mobile applications . 
              </p>
            </div>
            <div className="my-intro-div">
              <div className="my-intro-buttons">
                {" "}
                  <button className="button1" onClick={() => setTheme('theme-light-gray')}></button>
          <button className="button2" onClick={() => setTheme('theme-black')}></button>
          <button className="button3" onClick={() => setTheme('theme-white')}></button>
              </div>

              <div>
                <p className={`my-intro-location ${theme}`}>
                  37.8136° S, 144.9631° DELHI, INDIA
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="hero-section-div1" id="hero-section-div1"   >
                        <p className="hero-section-div1-based-in-india" >
                            Based in India  {<MdOutlineArrowRightAlt className="arrowright" />} <strong className="hero-section-div1-based-in-india"> {formatTime()}</strong>
                        </p>
                        <p className="hero-section-div1-open-to-work">
                            <strong>✦ </strong>
                            Status {<MdOutlineArrowRightAlt className="arrowright" />} <strong className="hero-section-div1-open-to-work">Open to Work</strong>
                        </p>
                    </div> */}
        {/* <hr className="hero-section-hr-1" /> */}

        {/* <div className="hero-section-div2">
                        <p>
                            Currently {<MdOutlineArrowRightAlt className="arrowright" />}
                            <strong> Wordpress Developer @</strong> <a href="https://webimpetus.com/" target="_blank" className="company-name-a-hero-section"><strong>Web Impetus</strong></a>
                        </p>
                        <p>
                            Location {<MdOutlineArrowRightAlt className="arrowright" />}<strong> Noida</strong>
                        </p>

                        <p >
                            Position {<MdOutlineArrowRightAlt className="arrowright" />}<strong> Frontend Developer</strong>
                        </p>

                    </div> */}
        <p className="hero-section-p-status">
          <strong>✦ </strong>
          Status {<MdOutlineArrowRightAlt className="arrowright" />}{" "}
          <strong>Open to Work</strong>
        </p>

        {/* {mode ? (
          <button
            onClick={handleMode}
            style={{
              position: "fixed",
              top: "350px",
              right: "20px",
              height: "50px",
              width: "50px",
              borderRadius: "50px",
            }}
          >
            <CiDark style={{ height: "2rem", width: "2rem" }} />
          </button>
        ) : (
          <button
            onClick={handleMode}
            style={{
              position: "fixed",
              top: "350px",
              right: "20px",
              height: "50px",
              width: "50px",
              borderRadius: "50px",
            }}
          >
            <CiLight style={{ height: "2rem", width: "2rem" }} />
          </button>
        )} */}
      </header>
      {/* <hr className="hero-section-hr" /> */}

      <Experience />
      
        <Marquee pauseOnHover autoFill gradient className="marquee">
          <h1 className="marquee-h1">
            HTML
            {/* <span ref={headingRef} className="hero-section-main-intro-span-gilroy">&</span> */}
          </h1>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="black"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>
          <h1 className="marquee-h1">
            CSS
            {/* <span ref={headingRef} className="hero-section-main-intro-span-gilroy">&</span> */}
          </h1>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>
          {/* <h1 ref={h1Ref} className="hero-section-h1-intro-main">
                            DEVELOPER</h1> */}

          <h1 className="marquee-h1">REACT</h1>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>

          <h1 className="marquee-h1">JAVASCRIPT</h1>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>
          {/* <div className="hero-section-div-title">
                            <h1 className="hero-section-h1-intro" data-value="Hi, this is Piyush."
                                style={{ marginTop: "-0px" }} >
                                Hi, this is Piyush.
                            </h1>

                        </div> */}
          {/* <h1 style={{ color: "white" }}>
                            /GSAP
                        </h1> */}
          <h1 className="marquee-h1">
            GSAP
            {/* <span ref={headingRef} className="hero-section-main-intro-span-gilroy">i</span>
                        GNER */}
          </h1>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>
          <h1 className="marquee-h1">
            Web Development
            {/* <span ref={headingRef} className="hero-section-main-intro-span-gilroy">i</span>
                        GNER */}
          </h1>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>
          <h1 className="marquee-h1">
            Figma
            {/* <span ref={headingRef} className="hero-section-main-intro-span-gilroy">i</span>
                        GNER */}
          </h1>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>
          <h1 className="marquee-h1">
            MongoDB
            {/* <span ref={headingRef} className="hero-section-main-intro-span-gilroy">i</span>
                        GNER */}
          </h1>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>
          <h1 className="marquee-h1">
            Node.js
            {/* <span ref={headingRef} className="hero-section-main-intro-span-gilroy">i</span>
                        GNER */}
          </h1>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>
          <h1 className="marquee-h1">
            Express
            {/* <span ref={headingRef} className="hero-section-main-intro-span-gilroy">i</span>
                        GNER */}
          </h1>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>

          <h1 className="marquee-h1">
            ELECTRON.JS
            {/* <span ref={headingRef} className="hero-section-main-intro-span-gilroy">i</span>
                        GNER */}
          </h1>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>
          <h1 className="marquee-h1">
            Three.js
            {/* <span ref={headingRef} className="hero-section-main-intro-span-gilroy">i</span>
                        GNER */}
          </h1>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 168 193"
            fill="none"
          >
            <path
              d="M158.634 123.324C145.127 115.606 120.688 114.32 90.4593 96.3117C120.688 78.9466 145.127 77.0171 158.634 69.2993C165.708 65.4403 170.21 58.3656 165.065 49.3615C159.92 40.3573 150.916 41.0005 143.841 45.5026C130.978 52.5772 117.472 73.1582 87.2435 91.1665C87.2435 55.1499 98.1772 32.6395 98.1772 17.2038C98.1772 8.19963 94.3182 0.481812 84.0278 0.481812C73.7373 0.481812 69.8784 8.19963 69.8784 17.2038C69.8784 32.6395 80.812 55.1499 80.812 91.1665C50.5838 73.1582 37.0775 52.5772 24.2145 45.5026C17.1398 41.0005 8.77878 40.3573 2.99039 49.3615C-2.15484 58.3656 2.34724 65.4403 9.42193 69.2993C22.9282 77.0171 47.368 78.9466 77.5962 96.3117C47.368 114.32 22.9282 115.606 9.42193 123.324C2.34724 127.826 -2.15484 134.901 2.99039 143.905C8.77878 152.909 17.1398 152.266 24.2145 147.764C37.0775 140.046 50.5838 119.465 80.812 101.457C80.812 137.474 69.8784 160.627 69.8784 176.063C69.8784 184.424 73.7373 192.142 84.0278 192.142C94.3182 192.142 98.1772 184.424 98.1772 176.063C98.1772 160.627 87.2435 137.474 87.2435 101.457C117.472 119.465 130.978 140.046 143.841 147.764C150.916 152.266 159.92 152.909 165.065 143.905C170.21 134.901 165.708 127.826 158.634 123.324Z"
              fill="#D6D1CE"
            />
          </svg>
        </Marquee>
      <Services />

      {/* <svg style={{ display: "none" }}>
                         <filter id='noiseFilter'>
                             <feTurbulence
                                 // type='fractalNoise'
                                 baseFrequency='9.6'
                                 stitchTiles='stitch'
                             />
                         </filter>
                     </svg> */}
      <section id="Project" data-scroll-section>
        <div className="Projects">
          <div className="project-h1-div">
            <h1 className="Project-h1">Projects</h1>
          </div>
          <div className="grainy">
            <div
              className="project-container"
              onClick={handleClick}
              style={{
                cursor: "pointer",
              }}
            >
              <div className="project-card">
                <slot name="media">
                  <video
                    src={noteApp}
                    autoPlay
                    muted
                    loop
                    className="video"
                  ></video>
                </slot>
              </div>
              {/* <div className='div-circle-hover'
                                         style={{
                                             opacity: hovered ? 1 : 0,
                                             // transform: hovered ? 'translate(-50%, -50%) scale(1)' : 'scale(0.8)',
                                             // transition: 'opacity 0.5s, transform 0.5s',
                                             left: mousePosition.x + 250,
                                             top: mousePosition.y - 100,
                                             transition: 'opacity 0.3s ease, transform 0.3s ease',
                                         }}>
                                         Play
                                     </div> */}
              <div className="project-card-div">
                <div className="project-card-div-button-1">React/Vite</div>
                <div className="project-card-div-button-2">
                  HTML . Css . JavaScript . TypeScript . Electron.js
                </div>
              </div>

              <div className="project-card-div-2">
                <h1 className="project-div-2-h1">Note App</h1>
                <p className="project-div-2-h2">
                  Desktop App Development . Logic Building
                </p>
              </div>
            </div>

            {/* ................................................................................ */}
            <div className="Project-container-gird">
              <div className="project-container-2">
                <div
                  className="project-card-2"
                  onClick={handleClick_1}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <slot name="media">
                    <video
                      src={invoice}
                      muted
                      className="video"
                      autoPlay
                    ></video>
                    {/* <image href={ino} /> */}
                  </slot>
                </div>
                <div className="project-card-div">
                  <div className="project-card-div-button-1">React/Vite</div>
                  <div className="project-card-div-button-2">
                    HTML . Css . JavaScript
                  </div>
                </div>

                <div className="project-card-div-2">
                  <h1 className="project-div-2-h1">Invoice Genrator</h1>
                  <p className="project-div-2-h2">
                    Web Development . Logic Building
                  </p>
                </div>
              </div>
              <div className="project-container-3">
                <div
                  className="project-card-3"
                  onClick={handleClick_2}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <slot name="media">
                    <video src={compressor} className="video" autoPlay></video>
                  </slot>
                </div>
                <div className="project-card-div">
                  <div className="project-card-div-button-1">React/Vite</div>
                  <div className="project-card-div-button-2">
                    HTML . Css . JavaScript
                  </div>
                </div>

                <div className="project-card-div-2">
                  <h1 className="project-div-2-h1">Image-Compressor</h1>
                  <p className="project-div-2-h2">
                    Web Development . Logic Building
                  </p>
                </div>
              </div>
              <div className="project-container-4">
                <div
                  className="project-card-4"
                  onClick={handleClick_3}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <slot name="media">
                    <video src={video} muted className="video" autoPlay></video>
                  </slot>
                </div>
                <div className="project-card-div">
                  <div className="project-card-div-button-1">React</div>
                  <div className="project-card-div-button-2">
                    HTML . Css . JavaScript . GSAP
                  </div>
                </div>

                <div className="project-card-div-2">
                  <h1 className="project-div-2-h1">FoodDost</h1>
                  <p className="project-div-2-h2">
                    Web Development . Frontend Development
                  </p>
                </div>
              </div>
            </div>
                  
                 
   
            <div />
            <div style={{  marginTop:"50px" ,display:"flex" ,justifyContent:"center"}}>
<Link  path={"/projects"}   className="project-card-div-button-1"  style={{ textDecoration: "none"  , color:"black", marginTop:"50px" }} to="/Projects">
                  View All
                  </Link>
            </div>
             
          </div>
          {/* <marquee style={{ color: "white" }}>hi
                                 hlw
                                 how r you
                             </marquee> */}
        </div>
      </section>

      <Contact />
    </>
  );
};

export default Home;
